var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashCanBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.0059C1 17.1059 1.9 18.0059 3 18.0059H11C12.1 18.0059 13 17.1059 13 16.0059V4.00586H1V16.0059ZM3 6.00586H11V16.0059H3V6.00586ZM10.5 1.00586L9.5 0.00585938H4.5L3.5 1.00586H0V3.00586H14V1.00586H10.5Z",
    fill: "#805D57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanBrown);
export default __webpack_public_path__ + "static/media/trash_can_brown.82e586da.svg";
export { ForwardRef as ReactComponent };